export const TARGETING_EVENT_NAME = `targeting-changed`
export const VSLY_CART_TOKEN_ATTR_KEY = `vslyCT`
export const VSLY_CART_SUBS_ATTR_KEY = `vslySUBS`
export const VSLY_SID_ATTR_KEY = `vslySID`
export const VSLY_UID_ATTR_KEY = `vslyUID`
export const REDIRECTION_URL_PARAM = `vsly-redirected-from`
export const REDIRECTION_URL_EVENT_PARAM = `vsly-redirected-event`
export const THEME_TEST_KEY = 'vslyThemeTest'
